import { Drawer, Stack, Typography, Box, Button } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";

const EditCustomer = (props) => {
  const loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  const [username, setUserName] = useState(props.selectedUser.username);
  const [lasName, setLasName] = useState(props.selectedUser.Lastname);
  const [type, setType] = useState(props.selectedUser.Type);
  const [mobile, setmobile] = useState(props.selectedUser.phonenumber);
  const [email, setemail] = useState(props.selectedUser.email);
  const [Language, setLanguage] = useState(props.selectedUser.Language);
  const [company, setcompany] = useState(props.selectedUser.company);
  const [City, setCity] = useState(props.selectedUser.city);
  const [state, setState] = useState(props.selectedUser.state);
  const [postalcode, setpostalcode] = useState(props.selectedUser.postalcode);
  const [Country, setCountry] = useState(props.selectedUser.country);
  const [Address, setAddress] = useState(props.selectedUser.address);

  const [facebook, setfacebook] = useState(props.selectedUser.facebookId);
  const [teams, setteams] = useState(props.selectedUser.teamsID);
  const [twitter, settwitter] = useState(props.selectedUser.twitterId);
  const [whatsapp, setwhatsapp] = useState(props.selectedUser.whatsappnumber);

  const updateEditvalue = async () => {
    if (username == "") {
      toast.warn("Username is Required", toaststyle);
      return;
    } else if (email == "") {
      toast.warn("Email is Required", toaststyle);
      return;
    } else if (mobile == "") {
      toast.warn("Phone Number is Required", toaststyle);
      return;
    }
    let body = {
      language: Language,
      Lastname: lasName,
      address: Address,
      city: City,
      company: company,
      country: Country,
      email: email,
      facebookId: facebook,
      type: type,
      phonenumber: mobile,
      postalcode: postalcode,
      state: state,
      teamsId: teams,
      twitterId: twitter,
      username: username,
      whatsappnumber: whatsapp,
      id: props.selectedUser.id,
      agent_id: loggedInAgent.agent_id,
    };

    axios
      .post(BaseUrl + "/users/updateClient", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.status) {
          props.setshowUserContactDetail(false);
          props.setsetshowEditCustomer(false);
          props.listContact();
          props.setselectedUser();
          toast.success(res.data.message, toaststyle);
        } else {
          props.setsetshowEditCustomer(false);
          toast.warn(res.data.message, toaststyle);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <Drawer
      anchor="right"
      open={props.showEditCustomer}
      onClose={() => {
        props.setsetshowEditCustomer(false);
      }}
    >
      <Box
        sx={{
          width: "30rem",
        }}
      >
        {/* Drawer head start */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="p-3 shadowDrawer"
        >
          <Typography variant="h3" gutterBottom className="drawer-title">
            Edit Customer
          </Typography>
        </Stack>
        {/* Drawer head end */}
        {/* Drawer Content start */}
        <Stack style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}>
          <form
            className="fillter_form2 CONTACT-LIST-AREA"
            style={{ height: "85vh", overflowY: "scroll", padding: "15px" }}
          >
            <div className="row row-cols-2">
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Lastname</label>
                <input
                  type="text"
                  className="form-control"
                  value={lasName}
                  onChange={(e) => {
                    setLasName(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Email <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => {
                    setemail(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Phone Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  maxLength="15"
                  className="form-control"
                  value={mobile}
                  onChange={(e) => {
                    setmobile(e.target.value.replace(/[^\d]/, ""));
                  }}
                />
              </div>

              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Type</label>
                <input
                  type="text"
                  className="form-control"
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                />
              </div>

              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Language</label>
                <input
                  type="text"
                  className="form-control"
                  value={Language}
                  onChange={(e) => {
                    setLanguage(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  value={Address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Company</label>
                <input
                  type="text"
                  className="form-control"
                  value={company}
                  onChange={(e) => {
                    setcompany(e.target.value);
                  }}
                />
              </div>

              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  value={City}
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  value={state}
                  onChange={(e) => {
                    setState(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Postal Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={postalcode}
                  onChange={(e) => {
                    setpostalcode(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  value={Country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                  }}
                />
              </div>
            </div>
          </form>
        </Stack>
        {/* Drawer Content end */}
        {/* Drawer footer start */}
        <Stack
          className="p-2"
          sx={{
            position: "absolute",
            bottom: "0",
            background: "#f9f9f9",
            width: "100%",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
          direction="row"
          justifyContent="space-between"
          alignContent="center"
        >
          <Button
            variant="contained"
            className="me-2 w-100"
            sx={{
              textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
              textTransform: "Capitalize",
            }}
            color="error"
            disableElevation
            onClick={() => {
              props.setsetshowEditCustomer(false);
            }}
          >
            Close
          </Button>
          <Button
            form="form1"
            className="w-100"
            variant="contained"
            disableElevation
            onClick={(e) => {
              updateEditvalue(e);
            }}
            sx={{
              textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
              textTransform: "Capitalize",
            }}
            id="add_customer_Submit"
          >
            Update
          </Button>
        </Stack>
        {/* Drawer footer end */}
      </Box>
    </Drawer>
  );
};

export default EditCustomer;
